export default "__VITE_ASSET__hgOXErwM__"